<template>
  <div class="t9_visitors wrapper">
    <div class="content" ref="contentLayer" :style="{height: contentH + 'px'}">
      <!--发布list-->
      <div class="common-nodata-item" v-if="noData">暂无数据</div>
      <mt-loadmore :bottom-method="loadMore" :bottom-all-loaded="!hasMore" ref="loadmore">
        <ul>
          <li v-for="(item,index) in list" class="item border-bottom">
            <img :src="item.headimgurl" />
            <div class="username">{{item.username}}</div>
          </li>
        </ul>
      </mt-loadmore>
      <div class="common-nodata-item" v-if="allLoad">已加载全部数据</div>
    </div>
    <!-- lj53 -->
    <BtnBackLayout4></BtnBackLayout4>
  </div>
</template>
<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { Loadmore } from "mint-ui"; //上拉刷新
import { mapState, mapMutations } from "vuex";
import Vue from "vue";
Vue.component(Loadmore.name, Loadmore);
const BtnBackLayout4 = () => import("@/components/btn_back_layout4");
export default {
  components: {
    BtnBackLayout4
  },
  data() {
    return {
      //列表
      noData: false,
      allLoad: false,
      hasMore: true,
      loading: true,
      pageIndex: 1,
      offset: 0,
      pageSize: 20,
      contentH: 0,
      list: []
    };
  },
  computed: {
    ...mapState(["pageInfo", "shareSpreadInfo"])
  },
  watch: {},
  filters: {},
  methods: {
    loadMore() {
      const that = this;
      if (that.hasMore && !that.loading) {
        that.pageIndex++;
        that.loadData();
      }
    },
    loadData() {
      let that = this;
      that.loading = true;
      let offset = that.pageIndex * that.pageSize - that.pageSize;
      let size = that.pageSize;
      util.checkMapStateCallback(that, ["pageInfo"]).then(() => {
        comreq
          .listPageBrowserDetails(parseInt(this.pageInfo.PageId), offset, size)
          .then(data => {
            if (data.obj.total == 0) {
              that.noData = true;
            } else {
              that.$refs.loadmore.onBottomLoaded();
              that.noData = false;
              that.loading = false;
              let list = [];
              data.obj.list.forEach(e => {
                list.push(e);
              });
              that.list = that.list.concat(list);
              if (data.obj.total <= that.list.length) {
                that.hasMore = false;
                that.allLoad = true;
              }
              if (that.pageIndex == 1) {
                that.$nextTick(() => {
                  that.$refs.contentLayer.scrollTop = 0;
                });
              }
            }
            console.log("围观人数", data.obj);
          });
      });
    }
  },
  mounted() {
    let that = this;
    that.$nextTick(function() {
      that.contentH =
        document.documentElement.clientHeight -
        that.$refs.contentLayer.getBoundingClientRect().top -
        10;
    });
    that.loadData();
  }
};
</script>
<style lang="stylus" scoped>
.wrapper {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
  background-color: #ffffff;
}

.content {
  // position: absolute;
  // left: 0;
  // right: 0;
  // top: 0.9rem;
  overflow: auto;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  // bottom: 0;
  // bottom: 0.5rem;
}

.content ul {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  // padding: 0 0.6rem
}

.item {
  width: 90%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0;
  position: relative;
}

.item > img {
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 0.8rem;
  display: block;
}

.item .username {
  flex: 1;
  text-align: right;
}

.common-nodata-item {
  line-height: 0.8rem;
  font-size: 0.24rem;
  color: #212121;
  text-align: center;
}
</style>